module.exports = __webpack_public_path__ + "static/media/close.aada560f.svg";